'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildQuickReply;

var _immutable = require('immutable');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _QuickReply = require('../../records/QuickReply');

var _QuickReply2 = _interopRequireDefault(_QuickReply);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildQuickReply(props) {
  if (!props) {
    return undefined;
  }

  var quickReplies = (0, _get2.default)('quickReplies', props);
  var allowMultiSelect = (0, _get2.default)('allowMultiSelect', props);
  var allowUserInput = (0, _get2.default)('allowUserInput', props);

  return (0, _QuickReply2.default)({
    quickReplies: (0, _immutable.OrderedSet)(quickReplies),
    allowMultiSelect: allowMultiSelect,
    allowUserInput: allowUserInput
  });
}
module.exports = exports['default'];